import { render, staticRenderFns } from "./scientific-analysis-results-panel.vue?vue&type=template&id=52c02343&scoped=true&"
import script from "./scientific-analysis-results-panel.ts?vue&type=script&lang=ts&"
export * from "./scientific-analysis-results-panel.ts?vue&type=script&lang=ts&"
import style0 from "./scientific-analysis-results-panel.scss?vue&type=style&index=0&id=52c02343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c02343",
  null
  
)

export default component.exports